/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createResendWelcomeEmailResponseFromDiscriminatorValue, serializeResendWelcomeEmailRequest, serializeResendWelcomeEmailResponse, type ErrorResponse, type InternalErrorResponse, type ResendWelcomeEmailRequest, type ResendWelcomeEmailResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/users/admins/resend-welcome
 */
export interface ResendWelcomeRequestBuilder extends BaseRequestBuilder<ResendWelcomeRequestBuilder> {
    /**
     * Resends the welcome email to an admin user in the organization
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ResendWelcomeEmailResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: ResendWelcomeEmailRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ResendWelcomeEmailResponse | undefined>;
    /**
     * Resends the welcome email to an admin user in the organization
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: ResendWelcomeEmailRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ResendWelcomeRequestBuilderUriTemplate = "{+baseurl}/api/organizations/users/admins/resend-welcome";
/**
 * Metadata for all the requests in the request builder.
 */
export const ResendWelcomeRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ResendWelcomeRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createResendWelcomeEmailResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeResendWelcomeEmailRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
